(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["enquiry-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const forms = document.querySelectorAll('.tm-enq__form');
    if (!forms.length) return;
    const params = new URLSearchParams(window.location.search);
    forms.forEach((form) => {
      const select = form.querySelector('[data-enquiry-type]');
      const piece = form.querySelector('[data-enquiry-piece]');
      const wanted = params.get('type');
      if (wanted && select) {
        const opt = Array.from(select.options).find((o) => o.dataset.key === wanted);
        if (opt) select.value = opt.value;
      }
      if (piece && params.get('piece')) piece.value = params.get('piece');
      const sync = () => {
        const key = select ? select.selectedOptions[0].dataset.key : '';
        form.querySelectorAll('[data-show]').forEach((el) => {
          el.hidden = !el.dataset.show.split(' ').includes(key);
        });
      };
      if (select) select.addEventListener('change', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exhibitions-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('exhibition-media')) {
    customElements.define(
      'exhibition-media',
      class ExhibitionMedia extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.tm-ex__track');
          this.total = Number(this.dataset.count) || 0;
          this.current = this.querySelector('[data-current]');
          this.buttons = Array.from(this.querySelectorAll('.tm-ex__btn'));
          this.buttons.forEach((b) => b.addEventListener('click', () => this.step(Number(b.dataset.dir))));
          this.track.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(this.raf);
              this.raf = requestAnimationFrame(() => this.update());
            },
            { passive: true }
          );
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.querySelectorAll('video').forEach((v) => {
              v.pause();
              v.controls = true;
            });
          }
          this.update();
        }
        tileWidth() {
          const first = this.track.children[0];
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 16;
          return first ? first.getBoundingClientRect().width + gap : 1;
        }
        perView() {
          return Math.max(1, Math.round((this.track.clientWidth + 16) / this.tileWidth()));
        }
        step(dir) {
          this.track.scrollBy({ left: dir * this.perView() * this.tileWidth(), behavior: 'smooth' });
        }
        update() {
          if (!this.current) return;
          const first = Math.round(this.track.scrollLeft / this.tileWidth()) + 1;
          const last = Math.min(this.total, first + this.perView() - 1);
          this.current.textContent = first === last ? String(first) : first + '–' + last;
          const [prev, next] = this.buttons;
          if (prev) prev.disabled = first <= 1;
          if (next) next.disabled = last >= this.total;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const openFromHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      const el = document.getElementById(id);
      if (el && el.classList.contains('tm-faq__item')) {
        el.open = true;
        el.scrollIntoView({ block: 'start' });
      }
    };
    window.addEventListener('hashchange', openFromHash);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openFromHash);
    } else {
      openFromHash();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-press"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('press-quotes')) {
    customElements.define(
      'press-quotes',
      class PressQuotes extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.tm-press__quote-track');
          this.total = Number(this.dataset.count) || 0;
          this.interval = Number(this.dataset.interval) || 0;
          this.current = this.querySelector('[data-current]');
          this.pos = 0;
          this.querySelectorAll('.tm-press__quote-btn').forEach((b) =>
            b.addEventListener('click', () => {
              this.go(this.pos + Number(b.dataset.dir));
              this.restart();
            })
          );
          // After a swipe or keyboard scroll settles, read the slide back from the scroll position.
          this.track.addEventListener(
            'scroll',
            () => {
              clearTimeout(this.settle);
              this.settle = setTimeout(() => {
                this.pos = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
                this.update();
              }, 140);
            },
            { passive: true }
          );
          this.track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') this.go(this.pos + 1);
            if (e.key === 'ArrowLeft') this.go(this.pos - 1);
          });
          this.paused = false;
          this.userPaused = false;
          ['mouseenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => (this.paused = true)));
          ['mouseleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => (this.paused = false)));
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // A visible pause control: anything that moves by itself for more than five seconds needs one.
          this.toggle = this.querySelector('[data-toggle]');
          if (this.toggle) {
            if (this.reduced || this.interval < 1000) this.toggle.hidden = true;
            this.toggle.addEventListener('click', () => {
              this.userPaused = !this.userPaused;
              this.toggle.textContent = this.userPaused ? 'Play' : 'Pause';
              this.toggle.setAttribute('aria-label', this.userPaused ? 'Play the quotes' : 'Pause the quotes');
              this.restart();
            });
          }
          this.restart();
          this.update();
        }
        disconnectedCallback() {
          clearInterval(this.timer);
        }
        go(i) {
          if (this.total < 2) return;
          this.pos = (i + this.total) % this.total;
          this.update();
          this.track.scrollTo({ left: this.pos * this.track.clientWidth, behavior: this.reduced ? 'auto' : 'smooth' });
        }
        restart() {
          clearInterval(this.timer);
          if (this.reduced || this.userPaused || this.total < 2 || this.interval < 1000) return;
          this.timer = setInterval(() => {
            if (!this.paused && !document.hidden) this.go(this.pos + 1);
          }, this.interval);
        }
        update() {
          if (this.current) this.current.textContent = String(this.pos + 1);
        }
      }
    );
  }

  if (!customElements.get('press-pages')) {
    customElements.define(
      'press-pages',
      class PressPages extends HTMLElement {
        connectedCallback() {
          this.links = Array.from(this.querySelectorAll('a[data-full]'));
          this.dialog = this.querySelector('dialog');
          // Without dialog support the links simply open each page full size.
          if (!this.dialog || typeof this.dialog.showModal !== 'function' || !this.links.length) return;
          this.img = this.dialog.querySelector('[data-img]');
          this.caption = this.dialog.querySelector('[data-caption]');
          this.counter = this.dialog.querySelector('[data-count]');
          this.links.forEach((a, i) =>
            a.addEventListener('click', (e) => {
              e.preventDefault();
              this.open(i);
            })
          );
          this.dialog.querySelectorAll('[data-step]').forEach((b) =>
            b.addEventListener('click', () => this.show(this.i + Number(b.dataset.step)))
          );
          this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
          this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') this.show(this.i + 1);
            if (e.key === 'ArrowLeft') this.show(this.i - 1);
          });
          this.dialog.addEventListener('close', () => {
            if (this.opener) this.opener.focus();
          });
        }
        open(i) {
          this.opener = this.links[i];
          this.show(i);
          this.dialog.showModal();
        }
        show(i) {
          const n = this.links.length;
          this.i = (i + n) % n;
          const a = this.links[this.i];
          this.img.src = a.dataset.full;
          this.img.alt = a.dataset.alt || '';
          this.caption.textContent = a.dataset.caption || '';
          this.counter.textContent = this.i + 1 + ' / ' + n;
          new Image().src = this.links[(this.i + 1) % n].dataset.full;
        }
      }
    );
  }

  (function () {
    function pressTarget() {
      var id = decodeURIComponent(window.location.hash.slice(1));
      if (id.indexOf('press-') !== 0) return null;
      var el = document.getElementById(id);
      if (!el) return null;
      var year = el.closest('details');
      if (year && !year.open) year.open = true;
      return el;
    }
    function scrollToPressTarget() {
      var el = pressTarget();
      if (!el) return;
      // The theme resets its scroll container while loading, so scroll once the page has settled.
      setTimeout(function () {
        el.scrollIntoView({ block: 'center', behavior: 'instant' });
      }, 300);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pressTarget);
    } else {
      pressTarget();
    }
    if (document.readyState === 'complete') {
      scrollToPressTarget();
    } else {
      window.addEventListener('load', scrollToPressTarget);
    }
    window.addEventListener('hashchange', scrollToPressTarget);
  })();

  } catch(e) { console.error(e); }
})();
})();
